import { IUNLegsItem } from "../Interfaces/nLegsInterfaces";
import { StepInstrumentType, StepOptionOrderType, StepOrderSide, VolumeCalculationType } from "../Interfaces/stepInterfaces";

export const getNLegPreviewOptionOrderType = (item: IUNLegsItem) =>
  item.OptionOrderType ?? item.optionOrderTypeEnum ?? item.optionOrderType;

export const getNLegPreviewSide = (item: IUNLegsItem) =>
  item.orderSide === StepOrderSide.Buy ? "خرید" : item.orderSide === StepOrderSide.Sell ? "فروش" : "—";

export const getNLegPreviewOptionType = (item: IUNLegsItem, instrumentType?: StepInstrumentType) => {
  if (instrumentType !== StepInstrumentType.Option) return "—";
  const type = getNLegPreviewOptionOrderType(item);
  return type === StepOptionOrderType.Offset ? "Offset" : type === StepOptionOrderType.Open ? "Open" : "—";
};

export const getNLegPreviewVolumeMethod = (type?: VolumeCalculationType | null) => {
  switch (type) {
    case VolumeCalculationType.FixedAmount: return "مقدار ثابت";
    case VolumeCalculationType.PortfolioPercent: return "درصد پورتفو";
    case VolumeCalculationType.AssetPercent: return "درصد دارایی";
    case VolumeCalculationType.TargetPortfolioPercent: return "درصد هدف پورتفو";
    case VolumeCalculationType.BuyingPowerPercent: return "درصد قدرت خرید";
    case VolumeCalculationType.FixedCapitalAmount: return "مبلغ ثابت سرمایه";
    default: return "—";
  }
};
